import axios from '@/axios'
import { token } from '@/utils'
import { METHODS } from '@/enum'
import { SceneKeyType } from '@/enum'
import type { Host, Order } from '@/types/response'
import { Page } from './interface'

export const enum APIS {
  APPLIST = '/upgpu/api/v2.1/application/list',
  GPULIST = '/upgpu/api/v2.1/gpu/list',
  SIZE = '/infra/api/v2.1/sizes',
  REGION = '/infra/api/v2.1/regions',
  GPUIMAGE = '/upgpu/api/v2.1/gpu/images',
  IMAGE = '/infra/api/v2.1/images',
  GPUPRICE = '/infra/api/v2.1/gpu/order/price',
  GPUUSERPRICE = '/infra/api/v2.1/gpu/order/user/price',
  PRICE = '/infra/api/v2.1/order/price',
  CASH = '/billing/api/v1/user/money',
  GPU_ORDER = '/infra/api/v2.1/gpu/order',
  ORDER = '/infra/api/v2.1/order',
  GPU_PAY = '/order/api/v2.1/gpu/order/:order_uid/pay',
  PAY = '/order/api/v2.1/order/:order_uid/pay',
  GPU_ALIPAY = '/order/api/v2.1/gpu/order/:order_uid/qrcode/alipay',
  ALIPAY = '/order/api/v2.1/order/:order_uid/qrcode/alipay',
  // 微信支付
  GPU_WE_CHAT_PAY = '/order/api/v2.1/gpu/order/:order_uid/qrcode/wechat',
  WE_CHAT_PAY = '/order/api/v2.1/order/:order_uid/qrcode/wechat',
  GPU_ORDER_STATUS = '/order/api/v2.1/gpu/order/:order_uid',
  ORDER_STATUS = '/order/api/v2.1/order/:order_uid',
  GPU_ALIPAY_STATUS = '/order/api/v2.1/gpu/order/:order_uid/pay',
  ALIPAY_STATUS = '/order/api/v2.1/order/:order_uid/pay',
  USERPRICE = '/infra/api/v2.1/order/user/price',
  VOUCHERS = '/order/api/v2.1/vouchers',
  COUPONS = '/order/api/v2.1/cash/coupon',
  GPU_GIFT = '/order/api/v2.1/gift',
  GPU_RECEIVE = '/order/api/v2.1/gift/renew',
  RECOMMEND_REGION = '/infra/api/v2.1/region/recommend',
}
export const enum COMPUTER {
  AI_ORDER = '/shinichi/api/v2.1/tiio/resource',
  AI_ORDER_STATUS = '/shinichi/api/v2.1/tiio/resource/:order_uid',
  AI_PAY = '/order/api/v2.1/tiio/resource/:order_uid/pay',
  AI_ALIPAY = '/order/api/v2.1/tiio/resource/:order_uid/qrcode/alipay', // 阿里支付
  AI_WE_CHAT_PAY = '/order/api/v2.1/tiio/resource/:order_uid/qrcode/wechat',
  AI_PAY_STATUS = '/order/api/v2.1/tiio/resource/:order_uid/pay', // 支付状态
}

export function filterString(filter: Record<string, unknown>) {
  return Object.keys(filter)
    .map((key) => (filter[key] ? `${key},${filter[key]}` : ''))
    .filter((s) => !!s)
    .join(',')
}

export type HostQueryProps = {
  regionId?: number | string | null
  imageId: string | null
  minCPU: number
  maxCPU: number
  minMemory: number
  maxMemory: number
  des: string | null
  scene?: string
}
export function requestSize(opt: Partial<HostQueryProps>) {
  const { des, ...props } = opt
  const params: { sortBy?: string; filterBy?: string } = {}
  if (des) params.sortBy = `${des === 'priceDay' ? 'a' : 'd'},${des}`
  const filters = filterString(props)
  if (filters) params.filterBy = filters
  return axios.request<{ items: Host.Size[]; totalItems: number }>({
    url: APIS.SIZE,
    method: METHODS.GET,
    params,
  })
}
export function requestGpuList(data?: { scene?: SceneKeyType }) {
  const filters = filterString(data && data.scene ? data : {})
  const params: { sortBy?: string; filterBy?: string } = {}
  if (filters) params.filterBy = filters
  return axios.request<{ items: Host.Size[]; totalItems: number }>({
    url: APIS.GPULIST,
    method: METHODS.GET,
    params,
  })
}
export function requestAppList() {
  return axios.request<{ items: Host.App[]; totalItems: number }>({
    url: APIS.APPLIST,
    method: METHODS.GET,
  })
}

export function requestRegions(data?: { scene?: SceneKeyType }) {
  const params: { filterBy?: string } = {}
  const filters = filterString(data && data.scene ? data : {})
  if (filters) params.filterBy = filters
  return axios.request<{ items: Host.Region[]; totalItems: number }>({
    url: APIS.REGION,
    method: METHODS.GET,
    params,
  })
}

export function requestImages(data?: { scene?: string }) {
  const params: { filterBy?: string } = {}
  const filters = filterString(data && data.scene ? data : {})
  if (filters) params.filterBy = filters
  return axios.request<{ items: Host.Image[]; totalItems: number }>({
    url: APIS.IMAGE,
    method: METHODS.GET,
    params,
  })
}
export function requestGpuImages(params: any) {
  // const params: { gpu_type?: string } = {}
  // params.gpu_type = data && data.gpu_type
  return axios.request<{ items: Host.Image[]; totalItems: number }>({
    url: APIS.GPUIMAGE,
    method: METHODS.GET,
    params,
  })
}

// 创建订单
export type OrderProps = {
  imageId?: string
  useOff?: boolean // 折扣 使用优惠券
  ipvmSizeId?: string | undefined
  payMethod?: string
  payPeriod?: number
  regionId?: string | null
  traffic?: number
  diskCap?: any
  gpuCount?: number | undefined
  gpuType?: string | undefined
  roomId?: number
  originTIIOResourceId?: number // 套餐id
}

export function requestPrice(data: OrderProps) {
  const isLogin = !!token()
  return axios.request<Host.Price>({
    url: isLogin ? APIS.USERPRICE : APIS.PRICE,
    method: METHODS.POST,
    data,
  })
}
// 询价
export function requestGpuPrice(data?: {
  useOff?: boolean // 折扣 使用优惠券
  [name: string]: any
}) {
  const isLogin = !!token()
  return axios.request<Host.Price>({
    url: isLogin ? APIS.GPUUSERPRICE : APIS.GPUPRICE,
    method: METHODS.POST,
    data,
  })
}

// 创建订单
export function requestOrder(data: OrderProps, gpuType?: 'Personal' | 'Enterprise' | 'Ai') {
  const _URL = {
    Personal: APIS.GPU_ORDER,
    Ai: COMPUTER.AI_ORDER,
  }
  return axios.request<{ orderUid?: string; uid?: string }>({
    url: _URL[gpuType as keyof typeof _URL] ?? APIS.ORDER,
    method: METHODS.POST,
    data,
  })
}

// 获取订单状态
export function requestOrderStatus(
  data: { order_uid: string },
  gpuType?: 'Personal' | 'Enterprise' | 'Ai',
) {
  const _URL = {
    Personal: APIS.GPU_ORDER_STATUS,
    Ai: COMPUTER.AI_ORDER_STATUS,
  }

  return axios.request<Order.Info>({
    url: _URL[gpuType as keyof typeof _URL] ?? APIS.ORDER_STATUS,
    method: METHODS.GET,
    data,
  })
}

// 支付宝支付 区分消费级 和 企业级
export function requestAliPay(
  data: { order_uid: string },
  gpuType?: 'Personal' | 'Enterprise' | 'Ai',
) {
  const _URL = {
    Personal: APIS.GPU_ALIPAY,
    Ai: COMPUTER.AI_ALIPAY,
  }
  return axios.request<{ qrCode: string }>({
    url: _URL[gpuType as keyof typeof _URL] ?? APIS.ALIPAY,
    method: METHODS.GET,
    data,
  })
}
// 使用余额支付
export function requestCashPay(
  data: { order_uid: string },
  gpuType?: 'Personal' | 'Enterprise' | 'Ai',
) {
  const _URL = {
    Personal: APIS.GPU_PAY,
    Ai: COMPUTER.AI_PAY,
  }
  return axios.request({
    url: _URL[gpuType as keyof typeof _URL] ?? APIS.PAY,
    method: METHODS.POST,
    data,
  })
}
// 微信支付
export function requestWeChatPay(
  data: { order_uid: string },
  gpuType?: 'Personal' | 'Enterprise' | 'Ai',
) {
  const _URL = {
    Personal: APIS.GPU_WE_CHAT_PAY,
    Ai: COMPUTER.AI_WE_CHAT_PAY,
  }
  return axios.request<{ qrCode: string }>({
    url: _URL[gpuType as keyof typeof _URL] ?? APIS.WE_CHAT_PAY,
    method: METHODS.GET,
    data,
  })
}

// 获取支付状态
export function requestAlipayStatus(
  data: { order_uid: string },
  gpuType?: 'Personal' | 'Enterprise' | 'Ai',
) {
  const _URL = {
    Personal: APIS.GPU_ALIPAY_STATUS,
    Ai: COMPUTER.AI_PAY_STATUS,
  }
  return axios.request<{ paid: boolean }>({
    url: _URL[gpuType as keyof typeof _URL] ?? APIS.ALIPAY_STATUS,
    method: METHODS.GET,
    data,
  })
}

type ICash = {
  cash: number // 余额
  credit: number // 授信额度
}
// 获取余额
export function requestCash() {
  return axios.request<ICash>({
    url: APIS.CASH,
    method: METHODS.GET,
  })
}

export function requestUserPrice(data: OrderProps) {
  return axios.request<Host.Price>({
    url: APIS.USERPRICE,
    method: METHODS.POST,
    data,
  })
}

export function requestVouchers(params: Page.Pagination) {
  return axios.request<{ items: Host.VoucherItem[]; totalItems: number }>({
    url: APIS.VOUCHERS,
    method: METHODS.GET,
    params,
  })
}
export function requestCouponVouchers(params?: Page.Pagination) {
  return axios.request<{
    items: Host.VoucherItem[]
    totalItems: number
    availableSumOfRemain: number
  }>({
    url: APIS.COUPONS,
    method: METHODS.GET,
    params,
  })
}
export function requestGiftList(
  params?: {
    sortBy?: string
    filterBy?: string
  } & Page.Pagination,
) {
  return axios.request<{ items: Host.VoucherItem[]; totalItems: number }>({
    url: APIS.GPU_GIFT,
    method: METHODS.GET,
    params,
  })
}

export function getRecommendRegion() {
  return axios.request<Host.Region>({
    url: APIS.RECOMMEND_REGION,
    method: METHODS.GET,
  })
}

// 发放体验金
export function requestGiftReceive() {
  return axios.request({
    url: APIS.GPU_RECEIVE,
    method: METHODS.POST,
  })
}
